import { formatarUnitario, totalLinha } from '../utils/arredondamentoUnitario';
import LiquidText from '../components/LiquidText';
import DeleteIcon from '../components/DeleteIcon';
import { OrcamentoDialog, OrcamentoIcon, OrcamentoFeedbackProvider, useOrcamentoFeedback } from '../components/OrcamentoUI';
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { invalidateCache } from './Orcamentos';
import { fmtMoney } from '../utils/moeda';
import './OrcamentoDetalhe.css';

const estadoLabel = (nome) => nome.replace(/_/g, ' ');

const newLinhaCompra = (n) => ({ _key: Date.now() + n, id: null, qtd: '', descricao: '', fornecedor: '', valor_unitario: '', valor_total: '', selecionada: false });
const newLinhaVenda  = (n) => ({ _key: Date.now() + n, id: null, qtd: '', descricao: '', valor_unitario: '', valor_total: '', na_guia: true });

const toNum = (v) => parseFloat(v) || 0;
const fmtQtd = (v) => { if (v === '' || v == null) return ''; const n = parseFloat(v); return isNaN(n) ? '' : (n % 1 === 0 ? String(Math.round(n)) : n.toFixed(1)); };

// Modal encomenda — edição + impressão
// Modal encomenda — edição + impressão (suporta múltiplas linhas via tabs)
function ModalEncomenda({ ef, onClose, onSaved, todasAsEncomendas }) {
    const { notify } = useOrcamentoFeedback();
    // Filtrar todas as linhas que pertencem a este mesmo número de encomenda
    const groupedEfs = (todasAsEncomendas || []).filter(item => item.numero === ef.numero);
    const [activeIdx, setActiveIdx] = useState(0);
    const [fornecedores, setFornecedores] = useState([]);

    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState('');

    const [forms, setForms] = useState(groupedEfs.map(item => ({
        id: item.id,
        linha_num: item.linha_num,
        fornecedor: item.fornecedor || '',
        descricao: item.descricao || '',
        qtd: item.qtd !== null && item.qtd !== undefined ? fmtQtd(item.qtd) : '',
        valor_unitario: formatarUnitario(item.valor_unitario),
        valor_total: item.valor_total !== null && item.valor_total !== undefined ? parseFloat(item.valor_total).toFixed(2) : '',
        notas: item.notas || '',
    })));

    const activeForm = forms[activeIdx] || forms[0];

    useEffect(() => {
        api.get('/fornecedores').then(r => setFornecedores(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    }, []);

    const updateActiveForm = (field, value) => {
        const next = [...forms];
        const updated = { ...next[activeIdx], [field]: value };
        if (field === 'qtd' || field === 'valor_unitario') {
            const q = parseFloat(field === 'qtd' ? value : updated.qtd) || 0;
            const vu = parseFloat(field === 'valor_unitario' ? value : updated.valor_unitario) || 0;
            updated.valor_total = totalLinha(q, vu);
        }
        next[activeIdx] = updated;
        setForms(next);
    };

    const handleSave = async () => {
        setSaving(true); setErr('');
        try {
            // Guardar todas as linhas sequencialmente
            for (const f of forms) {
                const payload = {
                    ...f,
                    qtd: parseFloat(String(f.qtd).replace(',', '.')) || 0,
                    valor_unitario: parseFloat(String(f.valor_unitario).replace(',', '.')) || 0,
                    valor_total: parseFloat(String(f.valor_total).replace(',', '.')) || 0,
                };
                await api.put(`/encomendas-fornecedor/${f.id}`, payload);
            }
            onSaved();
            onClose();
        } catch (e) {
            console.error('Erro ao guardar EF:', e);
            setErr(e.response?.data?.error || e.message || 'Erro ao guardar');
        } finally { setSaving(false); }
    };

    const handleImprimir = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${api.defaults.baseURL}/encomendas-fornecedor/${ef.id}/documento?formato=pdf`, { headers: { 'Authorization': `Bearer ${token}` } });
            if (!res.ok) throw new Error();
            window.open(URL.createObjectURL(await res.blob()), '_blank');
        } catch { notify('Erro ao gerar documento'); }
    };

    const handlePDF = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${api.defaults.baseURL}/encomendas-fornecedor/${ef.id}/documento?formato=pdf`, { headers: { 'Authorization': `Bearer ${token}` } });
            if (!res.ok) throw new Error();
            const blob = await res.blob();
            const filename = `EF_${ef.numero}.pdf`;
            if (window.showSaveFilePicker) {
                try {
                    const handle = await window.showSaveFilePicker({
                        suggestedName: filename,
                        types: [{ description: 'PDF Document', accept: { 'application/pdf': ['.pdf'] } }],
                    });
                    const writable = await handle.createWritable();
                    await writable.write(blob);
                    await writable.close();
                    return;
                } catch (err) {
                    if (err.name === 'AbortError') return;
                }
            }
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = filename;
            a.click();
        } catch { notify('Erro ao descarregar PDF'); }
    };

    return (
        <OrcamentoDialog onClose={onClose}>
            <div className="modal-ef" style={{ maxWidth: 640 }} onClick={e => e.stopPropagation()}>
                <div className={`modal-ef-header ${groupedEfs.length > 1 ? 'modal-ef-header-with-tabs' : ''}`}>
                    <div>
                        <span className="modal-ef-num">{ef.numero}</span>
                    </div>
                    <button className="modal-close" aria-label="Fechar" onClick={onClose}><OrcamentoIcon name="close" fallback="✕" /></button>
                </div>

                {groupedEfs.length > 1 && (
                    <div className="modal-ef-tabs">
                        {forms.map((f, i) => (
                            <button type="button"
                                aria-pressed={activeIdx === i}
                                key={f.id} 
                                className={`modal-ef-tab ${activeIdx === i ? 'active' : ''}`}
                                onClick={() => setActiveIdx(i)}
                            >
                                Item {i + 1}
                            </button>
                        ))}
                    </div>
                )}

                <div className="modal-form-body">
                    <div className="modal-form-grid">
                        <div className="modal-field full">
                            <label>FORNECEDOR</label>
                            <select value={activeForm.fornecedor} onChange={e => {
                                const f = fornecedores.find(x => x.nome === e.target.value);
                                updateActiveForm('fornecedor', e.target.value);
                                // Se mudar um fornecedor, opcionalmente mudar em todos? 
                                // Normalmente agrupadas devem ter o mesmo.
                            }}>
                                <option value="">-- Selecionar --</option>
                                {fornecedores.map(f => <option key={f.id} value={f.nome}>{f.nome}</option>)}
                            </select>
                        </div>
                        <div className="modal-field full">
                            <label>DESCRIÇÃO</label>
                            <input value={activeForm.descricao} onChange={e => updateActiveForm('descricao', e.target.value)} />
                        </div>
                        <div className="modal-field">
                            <label>QTD</label>
                            <input type="number" step="0.1" min="0" value={activeForm.qtd} 
                                onChange={e => updateActiveForm('qtd', e.target.value)}
                                onBlur={e => {
                                    const val = parseFloat(e.target.value);
                                    if (!isNaN(val)) updateActiveForm('qtd', fmtQtd(val));
                                }} />
                        </div>
                        <div className="modal-field">
                            <label>V. UNITÁRIO (s/ IVA)</label>
                            <input type="number" step="0.0001" min="0" value={activeForm.valor_unitario} onChange={e => updateActiveForm('valor_unitario', e.target.value)} />
                        </div>
                        <div className="modal-field">
                            <label>TOTAL (s/ IVA)</label>
                            <input type="number" step="0.01" min="0" value={activeForm.valor_total} onChange={e => updateActiveForm('valor_total', e.target.value)} />
                        </div>
                        <div className="modal-field full">
                            <label>NOTAS</label>
                            <textarea rows={2} value={activeForm.notas} onChange={e => updateActiveForm('notas', e.target.value)} />
                        </div>
                    </div>
                    {err && <div className="modal-err" style={{ fontSize: 13, background: '#fee2e2', color: '#b91c1c', padding: '10px 14px', borderRadius: 4, marginBottom: 12, border: '1px solid #fecaca' }}>{err}</div>}
                    <div className="modal-form-actions" style={{ justifyContent: 'space-between' }}>
                        <div data-liquid-actions="true" style={{ display: 'flex', gap: 8 }}>
                            <button className="btn-modal-cancel" onClick={handleImprimir} title="Imprimir Encomenda completa" style={{fontSize:11}}><OrcamentoIcon name="print" fallback="🖨️" /> Imprimir</button>
                            <button className="btn-modal-cancel" onClick={handlePDF} title="Baixar PDF completo" style={{fontSize:11}}><OrcamentoIcon name="document" fallback="📄" /> PDF</button>
                        </div>
                        <div data-liquid-actions="true" style={{ display: 'flex', gap: 8 }}>
                            <button className="btn-modal-cancel" onClick={onClose} style={{fontSize:11}}>Cancelar</button>
                            <button className="btn-modal-save" onClick={handleSave} disabled={saving} style={{fontSize:11, padding:'8px 12px'}}>
                                {saving ? 'A guardar...' : (groupedEfs.length > 1 ? `Guardar Todas (${groupedEfs.length})` : 'Guardar')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </OrcamentoDialog>
    );
}


function OrcamentoDetalheContent() {
    const { confirm, notify } = useOrcamentoFeedback();
    const { id } = useParams();
    const navigate = useNavigate();
    const isNew = id === 'novo';

    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(!isNew);
    const [fornecedores, setFornecedores] = useState([]);

    /* ---- Mostrar o fornecedor guardado na linha --------------------------
       A coluna orcamento_linhas_compra.fornecedor guarda DUAS coisas, conforme
       a época: um NÚMERO nas linhas vindas do sistema antigo (35.983 delas) e o
       NOME nas criadas aqui. O <select> compara com os nomes das opções, pelo
       que as linhas com número apareciam vazias — e liam-se como encomendas sem
       fornecedor.

       O número NÃO é traduzido para nome. Chegou a sê-lo, assumindo que era o id
       desta tabela, e estava errado: a linha "Aluguer Plataforma Machrent" guarda
       454, que aqui é a Hertz, e a "Vendap" guarda 277, que é a Telas Projecção.
       O número é o id do sistema anterior e a tabela de fornecedores do gest não
       guarda essa correspondência — traduzir seria inventar. Mostra-se o valor
       tal como está: é a verdade, e deixa ver que há ali alguma coisa. */
    const nomesFornecedores = useMemo(
        () => new Set(fornecedores.map(f => f.nome)), [fornecedores]);

    const mostrarFornecedor = (valor) => (valor || '').trim();

    const [clientes, setClientes] = useState([]);
    const [encomendas, setEncomendas] = useState([]); // POs já gerados
    const [neFicheiro, setNeFicheiro] = useState(null); // anexo nota encomenda cliente
    const [neUploading, setNeUploading] = useState(false);
    const [modalEf, setModalEf] = useState(null);     // EF aberto no modal
    const [gerandoEf, setGerandoEf] = useState(null); // índice de linha a gerar EF
    const [listaContratos, setListaContratos] = useState([]);
    const [listaGestores, setListaGestores] = useState([]);
    const [listaEstados, setListaEstados] = useState([]);

    const [initialSnapshot, setInitialSnapshot] = useState(null);
    const [showExitModal, setShowExitModal] = useState(false);

    const [form, setForm] = useState({
        data: new Date().toISOString().split('T')[0],
        cliente: '',
        cliente_id: '',
        projeto: '',
        ne_cliente: '',
        contacto_cliente: '',
        gestor_projeto: '',
        data_fatura: '',
        numero_fatura: '',
        estado: 'EM_ORCAMENTO',
        ordem_compra: '',
        obra_id: '',
        observacoes: '',
        contrato: '',
        data_entrega: '',
        morada_entrega: '',
    });

    const [linhasCompra, setLinhasCompra] = useState([newLinhaCompra(0)]);
    const [copiado, setCopiado] = useState(null);   // 'venda' | 'compra' | null — feedback do "copiar tudo"
    const [versaoAtiva, setVersaoAtiva]   = useState(1);
    const [versoesVenda, setVersoesVenda] = useState({ 1: [newLinhaVenda(0)] });
    const [compraPage, setCompraPage] = useState(0);
    const COMPRA_POR_PAGINA = 20;
    const [obraAssociada, setObraAssociada] = useState(null);

    const linhasVendaAtiva = versoesVenda[versaoAtiva] || [newLinhaVenda(0)];

    // Fetch fornecedores, clientes e config em paralelo
    useEffect(() => {
        Promise.all([
            api.get('/fornecedores').then(r => setFornecedores(Array.isArray(r.data) ? r.data : [])).catch(() => {}),
            api.get('/clientes').then(r => setClientes(Array.isArray(r.data) ? r.data : [])).catch(() => {}),
            api.get('/orcamentos-config/tipos/contrato').then(r => setListaContratos(Array.isArray(r.data) ? r.data : [])).catch(() => {}),
            api.get('/orcamentos-config/tipos/gestor').then(r => setListaGestores(Array.isArray(r.data) ? r.data : [])).catch(() => {}),
            api.get('/orcamentos-config/tipos/estado').then(r => setListaEstados(Array.isArray(r.data) ? r.data : [])).catch(() => {}),
        ]);
    }, []);

    const fetchEncomendas = useCallback(async () => {
        if (isNew) return;
        try {
            const res = await api.get(`/orcamentos/${id}/encomendas`);
            setEncomendas(res.data);
        } catch (err) { console.error(err); }
    }, [id, isNew]);

    const fetchOrcamento = useCallback(async () => {
        if (isNew) return;
        setLoading(true);
        try {
            const res = await api.get(`/orcamentos/${id}`);
            const d = res.data;

            setForm({
                data: d.data ? d.data.split('T')[0] : '',
                cliente: d.cliente || '',
                cliente_id: d.cliente_id || '',
                projeto: d.projeto || '',
                ne_cliente: d.ne_cliente || '',
                contacto_cliente: d.contacto_cliente || '',
                gestor_projeto: d.gestor_projeto || '',
                data_fatura: d.data_fatura ? d.data_fatura.split('T')[0] : '',
                numero_fatura: d.numero_fatura || '',
                estado: (d.estado === 'FACTURADO' ? 'FATURADO' : d.estado) || 'EM_ORCAMENTO',
                ordem_compra: d.ordem_compra || '',
                obra_id: d.obra_id || '',
                observacoes: d.observacoes || '',
                contrato: d.contrato || '',
                data_entrega: d.data_entrega ? d.data_entrega.split('T')[0] : '',
                morada_entrega: d.morada_entrega || '',
            });
            setNeFicheiro(d.ne_ficheiro || null);

            if (d.obra_id) setObraAssociada(d.obra_id);

            if (d.linhas_compra && d.linhas_compra.length > 0) {
                setLinhasCompra(d.linhas_compra.map((l, i) => ({
                    _key: i,
                    id: l.id,
                    arredondar_unitario: l.arredondar_unitario === true,
                    linha_num: l.linha_num,
                    codigo: l.codigo || '',
                    qtd: fmtQtd(l.qtd),
                    descricao: l.descricao || '',
                    fornecedor: l.fornecedor || '',
                    valor_unitario: l.valor_unitario ?? '',
                    valor_total: l.valor_total ?? '',
                    selecionada: false,
                })));
            } else {
                setLinhasCompra([newLinhaCompra(0)]);
            }

            if (d.linhas_venda && d.linhas_venda.length > 0) {
                const versoes = {};
                d.linhas_venda.forEach((l, i) => {
                    const v = l.versao || 1;
                    if (!versoes[v]) versoes[v] = [];
                    versoes[v].push({
                        _key: i + Math.random(),
                        id: l.id,
                    arredondar_unitario: l.arredondar_unitario === true,
                        linha_num: l.linha_num,
                        codigo: l.codigo || '',
                        qtd: fmtQtd(l.qtd),
                        descricao: l.descricao || '',
                        valor_unitario: l.valor_unitario ?? '',
                        valor_total: l.valor_total ?? '',
                        na_guia: l.na_guia !== false,
                    });
                });
                setVersoesVenda(versoes);
                setVersaoAtiva(d.versao_ativa || 1);
            } else {
                setVersoesVenda({ 1: [newLinhaVenda(0)] });
                setVersaoAtiva(1);
            }
        } catch (err) {
            await notify('Erro ao carregar orçamento');
            navigate('/orcamentos');
        } finally {
            setLoading(false);
        }
    }, [id, isNew, navigate, notify]);

    useEffect(() => {
        fetchOrcamento();
        fetchEncomendas();
    }, [fetchOrcamento, fetchEncomendas]);

    // Resets snapshot when navigating between different IDs
    useEffect(() => {
        setInitialSnapshot(null);
    }, [id]);

    const getCurrentSnapshot = useCallback(() => {
        const cleanCompra = linhasCompra.map(l => { 
            const { _key, _realIdx, ...rest } = l; 
            return rest; 
        });
        const cleanVenda = {};
        for (let v in versoesVenda) {
            cleanVenda[v] = versoesVenda[v].map(l => { 
                const { _key, _realIdx, ...rest } = l; 
                return rest; 
            });
        }
        return JSON.stringify({ form, linhasCompra: cleanCompra, versoesVenda: cleanVenda, versaoAtiva });
    }, [form, linhasCompra, versoesVenda, versaoAtiva]);

    // Set initial snapshot once loading is complete
    useEffect(() => {
        if (!loading && initialSnapshot === null) {
            // setTimeout ensures state batching has finished before saving snapshot
            setTimeout(() => setInitialSnapshot(getCurrentSnapshot()), 0);
        }
    }, [loading, initialSnapshot, getCurrentSnapshot]);

    const isDirty = initialSnapshot !== null && initialSnapshot !== getCurrentSnapshot();

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isDirty) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [isDirty]);

    useEffect(() => {
        window.__isOrcamentoDirty = isDirty;
        return () => { window.__isOrcamentoDirty = false; };
    }, [isDirty]);

    const handleSairRequest = () => {
        if (isDirty) {
            setShowExitModal(true);
        } else {
            navigate('/orcamentos');
        }
    };

    // Totais calculados
    const totalCompra = linhasCompra.reduce((s, l) => s + toNum(l.valor_total), 0);
    const totalVenda  = linhasVendaAtiva.reduce((s, l) => s + toNum(l.valor_total), 0);

    // Escreve na área de transferência e acende o ✓ durante 1,5 s. O 'qual'
    // identifica o botão, para acender só aquele que foi carregado.
    const copiarTexto = async (texto, qual) => {
        if (!texto) return;
        try {
            await navigator.clipboard.writeText(texto);
            setCopiado(qual);
            setTimeout(() => setCopiado(c => (c === qual ? null : c)), 1500);
        } catch {
            notify('Não foi possível aceder à área de transferência.');
        }
    };

    // Copia a descrição de TODAS as linhas de uma vez. O ⧉ de cada linha copia
    // só a sua, o que com dezenas de linhas é impraticável.
    // Separador de dois ENTERs (linha em branco): as descrições podem ter uma
    // segunda linha de detalhe, e com um só ENTER não se distinguia onde
    // acabava um artigo e começava o seguinte.
    // Linhas sem descrição são saltadas, para não deixar buracos no resultado.
    const copiarDescricoes = (linhas, qual) =>
        copiarTexto(linhas.map(l => (l.descricao || '').trim()).filter(Boolean).join('\n\n'), qual);
    const IVA_RATE = 0.23;
    const ivaVenda = totalVenda * IVA_RATE;
    const totalVendaComIva = totalVenda + ivaVenda;
    const margem = totalVenda - totalCompra;
    const pctMargem = totalCompra > 0 ? (margem / totalCompra) * 100 : 0;

    // --- Linhas Compra ---
    const updateLinhaCompra = (idx, field, value) => {
        setLinhasCompra(prev => {
            const next = prev.map((l, i) => {
                if (i !== idx) return l;
                const updated = { ...l, [field]: value };
                if (field === 'qtd' || field === 'valor_unitario') {
                    const q = toNum(field === 'qtd' ? value : l.qtd);
                    const vu = toNum(field === 'valor_unitario' ? value : l.valor_unitario);
                    updated.valor_total = totalLinha(q, vu);
                }
                return updated;
            });
            return next;
        });
    };

    const addLinhaCompra = () => {
        // A linha nova fica no fim, logo pode cair numa página que não a atual.
        // Saltar para a página onde ela ficou — antes vinha sempre para a
        // primeira, obrigando a navegar de volta até ao fim para a preencher.
        const idxNova = linhasCompra.length;
        setLinhasCompra(prev => [...prev, newLinhaCompra(prev.length)]);
        setCompraPage(Math.floor(idxNova / COMPRA_POR_PAGINA));
    };
    const removeLinhaCompra = (idx) => {
        if (linhasCompra.length <= 1) return;
        setLinhasCompra(prev => prev.filter((_, i) => i !== idx));
        // Apagar a última linha de uma página deixa-a sem conteúdo: recuar para
        // a última página que ainda existe, senão a tabela aparecia em branco.
        const ultimaPagina = Math.max(0, Math.ceil((linhasCompra.length - 1) / COMPRA_POR_PAGINA) - 1);
        setCompraPage(p => Math.min(p, ultimaPagina));
    };

    // --- Linhas Venda ---
    const updateLinhaVenda = (idx, field, value) => {
        setVersoesVenda(prev => {
            const lines = [...(prev[versaoAtiva] || [])];
            const updated = { ...lines[idx], [field]: value };
            if (field === 'qtd' || field === 'valor_unitario') {
                const q = toNum(field === 'qtd' ? value : lines[idx].qtd);
                const vu = toNum(field === 'valor_unitario' ? value : lines[idx].valor_unitario);
                updated.valor_total = totalLinha(q, vu);
            }
            lines[idx] = updated;
            return { ...prev, [versaoAtiva]: lines };
        });
    };

    /* Importação de uma ordem de compra do cliente em PDF.

       O servidor lê o ficheiro e devolve os artigos; nada é gravado por ele. As
       linhas são acrescentadas às que já estão no ecrã e só vão para a base de
       dados quando o utilizador carregar em guardar, como qualquer outra
       alteração. Assim uma leitura errada nunca entra sem ele a ver. */
    const ficheiroOrdemRef = useRef(null);
    const [aLerOrdem, setALerOrdem] = useState(false);

    const importarOrdemCompra = async (ficheiro) => {
        if (!ficheiro) return;
        setALerOrdem(true);
        try {
            const fd = new FormData();
            fd.append('ficheiro', ficheiro);
            const r = await api.post('/orcamentos/ordem-compra/ler', fd);
            const artigos = r.data?.artigos || [];
            if (artigos.length === 0) { notify('Não foi encontrado nenhum artigo neste ficheiro.'); return; }

            // A ordem imprime o total dos artigos. Se as linhas lidas não somarem
            // esse valor, alguma coisa escapou à leitura — e é preferível parar
            // do que encher o orçamento com números a menos.
            if (r.data?.confere === false) {
                const seguir = await confirm(
                    `Atenção: as ${artigos.length} linhas lidas somam ${fmtMoney(r.data.soma_linhas)}, `
                    + `mas a ordem declara ${fmtMoney(r.data.total_declarado)}. `
                    + `Pode faltar alguma coisa. Acrescentar mesmo assim?`);
                if (!seguir) return;
            }

            const novas = artigos.map((art, i) => ({
                ...newLinhaVenda(Date.now() % 100000 + i),
                qtd: String(art.quantidade),
                descricao: `${art.codigo} | ${art.descricao}`,
                valor_unitario: formatarUnitario(art.preco),
                valor_total: totalLinha(art.quantidade, art.preco),
            }));

            setVersoesVenda(prev => {
                const atuais = prev[versaoAtiva] || [];
                // Uma linha em branco no fim é o sítio natural para começar; as
                // que já tiverem conteúdo ficam todas.
                const preenchidas = atuais.filter(l => (l.descricao || '').trim() || l.qtd);
                return { ...prev, [versaoAtiva]: [...preenchidas, ...novas] };
            });
            // Sem caixa de confirmação: as linhas preenchidas no ecrã são a
            // prova de que correu bem, e uma caixa a dizer o mesmo só obriga a
            // um clique a mais.
        } catch (e) {
            notify(e.response?.data?.error || 'Não foi possível ler o ficheiro.');
        } finally {
            setALerOrdem(false);
            if (ficheiroOrdemRef.current) ficheiroOrdemRef.current.value = '';
        }
    };

    const addLinhaVenda = () => setVersoesVenda(prev => ({
        ...prev,
        [versaoAtiva]: [...(prev[versaoAtiva] || []), newLinhaVenda((prev[versaoAtiva] || []).length)]
    }));
    const removeLinhaVenda = (idx) => {
        setVersoesVenda(prev => {
            const lines = prev[versaoAtiva] || [];
            if (lines.length <= 1) return prev;
            return { ...prev, [versaoAtiva]: lines.filter((_, i) => i !== idx) };
        });
    };
    const moverLinhaVenda = (de, para) => setVersoesVenda(prev => {
        const linhas = [...(prev[versaoAtiva] || [])];
        if (de === para || de < 0 || para < 0 || de >= linhas.length || para >= linhas.length) return prev;
        linhas.splice(para, 0, linhas.splice(de, 1)[0]);
        return { ...prev, [versaoAtiva]: linhas };
    });
    const removerVersaoVenda = async () => {
        if (Object.keys(versoesVenda).length <= 1) return;
        const versao = versaoAtiva;
        if (!await confirm(`Eliminar a versão v${versao} e as suas linhas de venda? A alteração só fica definitiva ao guardar o orçamento.`)) return;
        const restantes = { ...versoesVenda };
        delete restantes[versao];
        setVersoesVenda(restantes);
        setVersaoAtiva(Math.max(...Object.keys(restantes).map(Number)));
    };
    const addVersaoVenda = () => {
        const novaVersao = Math.max(...Object.keys(versoesVenda).map(Number)) + 1;
        const linhasCopiadas = (versoesVenda[versaoAtiva] || []).map((l, i) => ({ ...l, _key: Date.now() + i, id: null }));
        setVersoesVenda(prev => ({ ...prev, [novaVersao]: linhasCopiadas }));
        setVersaoAtiva(novaVersao);
    };

    // --- Guardar ---
    const handleSave = async (exitAfter = false) => {
        setSaving(true);
        try {
            const payload = {
                ...form,
                obra_id: form.obra_id || null,
                data_fatura: form.data_fatura || null,
                versao_ativa: versaoAtiva,
                linhas_compra: linhasCompra.map((l, i) => ({ ...l, linha_num: i + 1 })),
                linhas_venda: Object.entries(versoesVenda).flatMap(([v, linhas]) =>
                    linhas.map((l, i) => ({ ...l, linha_num: i + 1, versao: parseInt(v) }))),
            };
            if (isNew) {
                invalidateCache();
                const res = await api.post('/orcamentos', payload);
                if (exitAfter === true) {
                    navigate('/orcamentos');
                } else {
                    navigate(`/orcamentos/${res.data.id}`);
                }
            } else {
                invalidateCache();
                await api.put(`/orcamentos/${id}`, payload);
                if (exitAfter === true) {
                    navigate('/orcamentos');
                } else {
                    setInitialSnapshot(null); // Force snapshot refresh
                    await fetchOrcamento();
                    await fetchEncomendas();
                }
            }
        } catch (err) {
            notify(err.response?.data?.error || 'Erro ao guardar');
        } finally {
            setSaving(false);
        }
    };

    // --- Apagar Encomenda a Fornecedor ---
    const handleApagarEF = async (ef) => {
        if (!await confirm(`Apagar a encomenda ${ef.numero}? Esta ação não pode ser revertida.`)) return;
        try {
            await api.delete(`/encomendas-fornecedor/${ef.id}`);
            await fetchEncomendas();
        } catch (err) {
            notify(err.response?.data?.error || 'Erro ao apagar encomenda');
        }
    };

    // --- Gerar Encomenda a Fornecedor ---
    const handleGerarEF = async (idx) => {
        // Se houver múltiplas selecionadas, usar esse array. Caso contrário só a linha idx.
        const selecionadas = linhasCompra.filter(x => x.selecionada || linhasCompra.indexOf(x) === idx);
        // Filtrar as que já têm EF
        const paraGerar = selecionadas.filter(x => !efDaLinha(x));

        if (paraGerar.length === 0) {
            // Se eu cliquei numa que já tem EF, abrir o modal dela
            const existing = efDaLinha(linhasCompra[idx]);
            if (existing) setModalEf(existing);
            return;
        }

        // Validações
        const semDesc = paraGerar.filter(x => !x.descricao && !x.qtd);
        if (semDesc.length > 0) {
            notify('Uma ou mais linhas selecionadas estão vazias.');
            return;
        }

        if (!paraGerar.every(x => x.fornecedor && x.fornecedor.trim())) {
            notify('Preencha o fornecedor em todas as linhas selecionadas.');
            return;
        }

        const fornecedorRef = paraGerar[0].fornecedor;
        if (!paraGerar.every(x => x.fornecedor === fornecedorRef)) {
             notify('As linhas selecionadas para a mesma encomenda devem pertencer ao mesmo fornecedor.');
             return;
        }

        if (isNew) {
            notify('Guarde o orçamento primeiro antes de gerar encomendas.');
            return;
        }

        if (!await confirm(`Deseja gerar uma encomenda fornecedor (${fornecedorRef}) com ${paraGerar.length} linha(s)?`)) return;

        try {
            setSaving(true);
            // Guardar o orçamento primeiro para persistir as linhas de compra
            await api.put(`/orcamentos/${id}`, {
                ...form,
                obra_id: form.obra_id || null,
                data_fatura: form.data_fatura || null,
                versao_ativa: versaoAtiva,
                linhas_compra: linhasCompra.map((l, i) => ({ ...l, linha_num: i + 1 })),
                linhas_venda: Object.entries(versoesVenda).flatMap(([v, linhas]) =>
                    linhas.map((l, i) => ({ ...l, linha_num: i + 1, versao: parseInt(v) }))),
            });
            // Recarregar para obter os IDs das linhas persistidas
            const orcRes = await api.get(`/orcamentos/${id}`);
            const linhasPersistidas = orcRes.data.linhas_compra || [];
            const linhasAtualizadas = linhasCompra.map((l, i) => ({
                ...l,
                id: linhasPersistidas[i]?.id || l.id,
                linha_num: i + 1,
            }));
            setLinhasCompra(linhasAtualizadas);

            const payload = {
                linhas: paraGerar.map(x => {
                    const origIdx = linhasCompra.indexOf(x);
                    const persistida = linhasAtualizadas[origIdx] || x;
                    return {
                        id: persistida.id,
                        linha_num: persistida.linha_num || origIdx + 1,
                        fornecedor: persistida.fornecedor,
                        descricao: persistida.descricao,
                        qtd: parseFloat(String(persistida.qtd || '').replace(',', '.')) || null,
                        valor_unitario: parseFloat(String(persistida.valor_unitario || '').replace(',', '.')) || null,
                        valor_total: parseFloat(String(persistida.valor_total || '').replace(',', '.')) || null,
                    };
                })
            };
            const res = await api.post(`/orcamentos/${id}/gerar-encomenda`, payload);

            // Atualizar o estado localmente se mudou no backend
            if (form.estado === 'EM_ORCAMENTO') {
                setForm(prev => ({ ...prev, estado: 'EM_PRODUCAO' }));
                invalidateCache();
            }

            await fetchEncomendas();
            setModalEf(res.data);
            // Limpar seleção
            setLinhasCompra(prev => prev.map(l => ({ ...l, selecionada: false })));
        } catch (err) {
            notify(err.response?.data?.error || 'Erro ao gerar encomenda');
        } finally {
            setSaving(false);
        }
    };

    const handleDuplicar = async () => {
        if (!await confirm('Duplicar este orçamento? Será criado um novo orçamento com os mesmos dados (sem encomendas a fornecedor).')) return;
        try {
            invalidateCache();
            const res = await api.post(`/orcamentos/${id}/duplicar`);
            navigate(`/orcamentos/${res.data.id}`);
        } catch (err) {
            notify(err.response?.data?.error || 'Erro ao duplicar orçamento');
        }
    };

    const handleConverterObra = async () => {
        if (!await confirm('Converter este orçamento em Obra?')) return;
        try {
            const res = await api.post(`/orcamentos/${id}/converter-obra`);
            await notify(`Obra criada! ID: ${res.data.obra_id}`);
            await fetchOrcamento();
        } catch (err) {
            notify(err.response?.data?.error || 'Erro ao converter');
        }
    };

    // Abrir PDF via Puppeteer numa nova janela para impressão
    const handleAbrirDocumento = async (tipo) => {
        try {
            if (!isNew) await handleSave();
            const baseURL = api.defaults.baseURL;
            const token = localStorage.getItem('token');
            const res = await fetch(`${baseURL}/orcamentos/${id}/documento?tipo=${tipo}&formato=pdf&versao=${versaoAtiva}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Erro ao gerar documento');
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (e) {
            notify(e.message || 'Erro ao abrir documento');
        }
    };

    // Download PDF
    const handleDownloadPDF = async (tipo) => {
        try {
            if (!isNew) await handleSave();
            const baseURL = api.defaults.baseURL;
            const token = localStorage.getItem('token');
            const res = await fetch(`${baseURL}/orcamentos/${id}/documento?tipo=${tipo}&formato=pdf&versao=${versaoAtiva}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Erro ao gerar PDF');
            const blob = await res.blob();
            
            // Nomenclatura sugerida: ORC.SPROD2026.16284.pdf
            const year = new Date().getFullYear();
            const prefix = tipo === 'orcamento' ? 'ORC' : 'GUIA';
            const filename = `${prefix}.SPROD${year}.${id}.pdf`;

            // Tentar usar File System Access API para "Gravar como..."
            if (window.showSaveFilePicker) {
                try {
                    const handle = await window.showSaveFilePicker({
                        suggestedName: filename,
                        types: [{ description: 'PDF Document', accept: { 'application/pdf': ['.pdf'] } }],
                    });
                    const writable = await handle.createWritable();
                    await writable.write(blob);
                    await writable.close();
                    return;
                } catch (err) {
                    if (err.name === 'AbortError') return;
                    console.error('Save picker error, fallback to default download', err);
                }
            }

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (e) {
            notify(e.message || 'Erro ao gerar PDF');
        }
    };

    /* A encomenda de uma linha.

       Procura-se pela chave verdadeira (orcamento_linha_id) e só se recorre ao
       número da linha quando ela não existe — são as encomendas antigas, criadas
       antes de essa coluna existir. É a mesma precedência que o servidor já usa
       para proteger as linhas com encomenda ao gravar.

       Antes procurava-se por POSIÇÃO na lista (índice + 1), o que só está certo
       enquanto a numeração for seguida. Não é: uma linha com encomenda não é
       apagada ao gravar mas também não é renumerada, e a partir daí abrem-se
       buracos. No orçamento 16087 são 254 linhas numeradas até 263 — e a etiqueta
       aparecia oito linhas acima do sítio certo. */
    const efDaLinha = (linha) => encomendas.find(e =>
        (e.orcamento_linha_id != null && linha.id != null)
            ? e.orcamento_linha_id === linha.id
            : (e.orcamento_linha_id == null && e.linha_num === linha.linha_num));

    if (loading) return <div className="ord-loading">A carregar orçamento...</div>;

    return (
        <div className="ord-page">
            <div className="top-bar">
                <div className="top-bar-left">
                    <button className="btn-back" onClick={handleSairRequest}>← Orçamentos</button>
                    <div className="top-bar-title">
                        <h1><OrcamentoIcon name="briefcase" fallback="💼" /> Orçamentos</h1>
                        <p>Gestão de orçamentos, clientes e fornecedores</p>
                    </div>
                </div>
                <div className="top-bar-actions">
                    {!isNew && obraAssociada && (
                        <button className="ord-btn ord-btn-obra" onClick={() => navigate(`/obras/${obraAssociada}`)}>
                            Ver Obra #{obraAssociada}
                        </button>
                    )}
                    {!isNew && !obraAssociada && (
                        <button className="ord-btn ord-btn-converter" data-liquid-secondary="true" onClick={handleConverterObra}>
                            <OrcamentoIcon name="building" fallback="" /> Converter em Obra
                        </button>
                    )}
                    {!isNew && (
                        <>
                            <button className="ord-btn ord-btn-doc" onClick={() => handleAbrirDocumento('orcamento')}><OrcamentoIcon name="print" fallback="🖨️" /> Imprimir</button>
                            <button className="ord-btn ord-btn-doc" onClick={() => handleDownloadPDF('orcamento')}><OrcamentoIcon name="document" fallback="📄" /> PDF</button>
                            <button className="ord-btn ord-btn-guia" onClick={() => handleAbrirDocumento('guia')}><OrcamentoIcon name="print" fallback="🖨️" /> Imprimir Guia</button>
                            <button className="ord-btn ord-btn-guia" onClick={() => handleDownloadPDF('guia')}><OrcamentoIcon name="truck" fallback="🚚" /> Guia PDF</button>
                        </>
                    )}
                    <button className="ord-btn ord-btn-save" onClick={() => handleSave(false)} disabled={saving}>
                        {saving ? 'A guardar...' : <><OrcamentoIcon name="save" fallback="💾" /> Guardar</>}
                    </button>
                </div>
            </div>

            <div className="ord-card">
                        {/* Header: ID + Data + Estado */}
                        <div className="ord-header-grid">
                        <div className="ord-field ord-field-id">
                            <label>ID TRABALHO</label>
                            <div className="ord-field-inline">
                                <div className="ord-id-box">{isNew ? 'NOVO' : id}</div>
                                {!isNew && <button type="button" className="btn-copy-desc"
                                    title="Copiar referência EF do trabalho" aria-label="Copiar referência EF do trabalho"
                                    onClick={() => copiarTexto(`EF-${form.data?.slice(0,4) || new Date().getFullYear()}-${id}`, 'id-trabalho')}>
                                    <OrcamentoIcon name={copiado === 'id-trabalho' ? 'check' : 'copy'} fallback={copiado === 'id-trabalho' ? '✓' : '⧉'} />
                                </button>}
                            </div>
                        </div>
                        <div className="ord-field">
                            <label>DATA</label>
                            <input type="date" value={form.data}
                                onChange={e => setForm({ ...form, data: e.target.value })} />
                        </div>
                        <div className="ord-field ord-estado-box">
                            <label>ESTADO TRABALHO</label>
                            <select
                                value={form.estado}
                                onChange={e => setForm({ ...form, estado: e.target.value })}
                                className={`ord-estado-select estado-${form.estado}`}
                            >
                                    {listaEstados.map(s => <option key={s.nome} value={s.nome}>{estadoLabel(s.nome)}</option>)}
                            </select>
                        </div>
                    </div>

                    {/* Campos principais */}
                    <div className="ord-main-grid">
                        <div className="ord-field">
                            <label>CLIENTE</label>
                            <select value={form.cliente_id || ''}
                                onChange={e => {
                                    const c = clientes.find(cl => cl.id === parseInt(e.target.value));
                                    setForm({ ...form, cliente_id: e.target.value, cliente: c ? c.nome : '' });
                                }}>
                                <option value="">-- Selecionar --</option>
                                {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                            </select>
                        </div>
                        <div className="ord-field">
                            <label>PROJECTO</label>
                            <div className="ord-field-inline">
                                <input type="text" value={form.projeto}
                                    onChange={e => setForm({ ...form, projeto: e.target.value })} />
                                {/* copia sempre em MAIÚSCULAS, seja como for que
                                    esteja guardado — o campo em si não é alterado */}
                                <button type="button" className="btn-copy-desc"
                                    title="Copiar o projeto em MAIÚSCULAS"
                                    onClick={() => copiarTexto((form.projeto || '').trim().toUpperCase(), 'projeto')}>
                                    <LiquidText>{copiado === 'projeto' ? '✓' : '⧉'}</LiquidText>
                                </button>
                            </div>
                        </div>
                        <div className="ord-field">
                            <label>CONTACTO CLIENTE</label>
                            <div className="ord-field-inline">
                                <input type="text" value={form.contacto_cliente}
                                    onChange={e => setForm({ ...form, contacto_cliente: e.target.value })} />
                                {/* mesma regra do PROJECTO: copia sempre em MAIÚSCULAS,
                                    seja como for que esteja guardado — o campo em si não
                                    é alterado */}
                                <button type="button" className="btn-copy-desc"
                                    title="Copiar o contacto em MAIÚSCULAS"
                                    onClick={() => copiarTexto((form.contacto_cliente || '').trim().toUpperCase(), 'contacto')}>
                                    <LiquidText>{copiado === 'contacto' ? '✓' : '⧉'}</LiquidText>
                                </button>
                            </div>
                        </div>
                        <div className="ord-field">
                            <label>GESTOR PROJ.</label>
                            <div className="ord-field-inline">
                                {listaGestores.length > 0 ? (
                                    <select value={form.gestor_projeto} onChange={e => setForm({ ...form, gestor_projeto: e.target.value })}>
                                        <option value="">-- Selecionar --</option>
                                        {listaGestores.map(g => <option key={g.id} value={g.nome}>{g.nome}</option>)}
                                    </select>
                                ) : (
                                    <input type="text" value={form.gestor_projeto}
                                        onChange={e => setForm({ ...form, gestor_projeto: e.target.value })} />
                                )}
                                <button type="button" className="btn-copy-desc"
                                    title="Copiar o gestor de projeto em MAIÚSCULAS" aria-label="Copiar o gestor de projeto em MAIÚSCULAS"
                                    disabled={!(form.gestor_projeto || '').trim()}
                                    onClick={() => copiarTexto((form.gestor_projeto || '').trim().toUpperCase(), 'gestor-projeto')}>
                                    <LiquidText>{copiado === 'gestor-projeto' ? '✓' : '⧉'}</LiquidText>
                                </button>
                            </div>
                        </div>
                        <div className="ord-field">
                            <label>CONTRATO</label>
                            {listaContratos.length > 0 ? (
                                <select value={form.contrato} onChange={e => setForm({ ...form, contrato: e.target.value })}>
                                    <option value="">-- Selecionar --</option>
                                    {listaContratos.map(c => <option key={c.id} value={c.nome}>{c.nome}</option>)}
                                </select>
                            ) : (
                                <input type="text" value={form.contrato}
                                    onChange={e => setForm({ ...form, contrato: e.target.value })}
                                    placeholder="Sem contratos configurados" />
                            )}
                        </div>
                        <div className="ord-field">
                            <label>ORDEM DE COMPRA</label>
                            <input type="text" value={form.ordem_compra}
                                onChange={e => setForm({ ...form, ordem_compra: e.target.value })} />
                        </div>
                        <div className="ord-field">
                            <label>DATA FATURA</label>
                            <input type="date" value={form.data_fatura}
                                onChange={e => setForm({ ...form, data_fatura: e.target.value })} />
                        </div>
                        <div className="ord-field">
                            <label>Nº FATURA</label>
                            <input type="text" value={form.numero_fatura}
                                onChange={e => setForm({ ...form, numero_fatura: e.target.value })} />
                        </div>
                        <div className="ord-field">
                            <label>DATA ENTREGA</label>
                            <input type="date" value={form.data_entrega || ''}
                                onChange={e => setForm({ ...form, data_entrega: e.target.value })} />
                        </div>
                        <div className="ord-field ord-field-obs">
                            <label>MORADA ENTREGA (para guia)</label>
                            <textarea value={form.morada_entrega || ''}
                                onChange={e => setForm({ ...form, morada_entrega: e.target.value })}
                                className="obs-textarea"
                                placeholder="Rua, Nº, Andar&#10;Código Postal, Localidade" />
                        </div>
                        <div className="ord-field ord-field-obs">
                            <label>OBSERVAÇÕES</label>
                            <textarea value={form.observacoes}
                                onChange={e => setForm({ ...form, observacoes: e.target.value })}
                                className="obs-textarea" />
                        </div>
                    </div>

                    {/* ==================== COMPRA ==================== */}
                    <div className="ord-section">
                    <div className="ord-section-title ord-section-title-compra" style={{display:'flex',alignItems:'center',gap:8}}>
                        <span>COMPRA</span>
                        <button className="btn-copy-all" onClick={() => copiarDescricoes(linhasCompra, 'compra')}
                            title="Copiar a descrição de todas as linhas, uma por linha">
                            <LiquidText>{copiado === 'compra' ? '✓ Copiado' : '⧉ Copiar descrições'}</LiquidText>
                        </button>
                    </div>
                    <div className="ord-table-wrap">
                        <table className="ord-table ord-table-compra">
                            <thead>
                                <tr>
                                    <th className="col-num">#</th>
                                    <th className="col-ef-check" title="Selecionar para Encomenda"></th>
                                    <th className="col-qtd">QTD</th>
                                    <th className="col-desc">DESCRIÇÃO</th>
                                    <th className="col-forn">FORNECEDOR</th>
                                    <th className="col-vunit">V. UNIT.</th>
                                    <th className="col-vtotal">TOTAL</th>
                                    <th className="col-ef">EF</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...linhasCompra].map((l, i) => ({ ...l, _realIdx: i }))
                                    .slice(compraPage * COMPRA_POR_PAGINA, (compraPage + 1) * COMPRA_POR_PAGINA)
                                    .map((l) => {
                                    const i = l._realIdx;
                                    const ef = efDaLinha(l);
                                    const isGerando = gerandoEf === i;
                                    return (
                                        <tr key={l._key} className={l.descricao || l.qtd ? 'linha-preenchida' : ''}>
                                            <td className="col-num td-num">{i + 1}</td>
                                            <td className="col-ef-check">
                                                <input type="checkbox"
                                                    disabled={!!ef}
                                                    checked={l.selecionada || false}
                                                    onChange={e => updateLinhaCompra(i, 'selecionada', e.target.checked)} />
                                            </td>
                                            <td className="col-qtd">
                                                <input type="number" value={l.qtd}
                                                    onChange={e => updateLinhaCompra(i, 'qtd', e.target.value)}
                                                    onBlur={e => {
                                                        const val = parseFloat(e.target.value);
                                                        if (!isNaN(val)) updateLinhaCompra(i, 'qtd', fmtQtd(val));
                                                    }}
                                                    className="inp-qtd" min="0" step="0.1" />
                                            </td>
                                            <td className="col-desc">
                                                <div className="td-desc-wrap">
                                                    <textarea value={l.descricao}
                                                        onChange={e => {
                                                            updateLinhaCompra(i, 'descricao', e.target.value);
                                                            e.target.style.height = 'auto';
                                                            e.target.style.height = e.target.scrollHeight + 'px';
                                                        }}
                                                        onFocus={e => {
                                                            e.target.style.height = 'auto';
                                                            e.target.style.height = e.target.scrollHeight + 'px';
                                                        }}
                                                        className="inp-desc inp-desc-ta"
                                                        rows={2} />
                                                    <button className="btn-copy-desc" title="Copiar descrição"
                                                        onClick={() => navigator.clipboard.writeText(l.descricao || '')}><OrcamentoIcon name="copy" fallback="⧉" /></button>
                                                </div>
                                            </td>
                                            <td className="col-forn">
                                                <select
                                                    value={mostrarFornecedor(l.fornecedor)}
                                                    onChange={e => updateLinhaCompra(i, 'fornecedor', e.target.value)}
                                                    className="inp-forn">
                                                    <option value="">-- Selecionar --</option>
                                                    {/* Fornecedor que já não está na lista — renomeado, desativado
                                                        ou apagado. Sem esta opção o <select> mostrava vazio e dava
                                                        a entender que a linha não tinha fornecedor nenhum. */}
                                                    {mostrarFornecedor(l.fornecedor)
                                                        && !nomesFornecedores.has(mostrarFornecedor(l.fornecedor)) && (
                                                        <option value={mostrarFornecedor(l.fornecedor)}>
                                                            {/^[0-9]+$/.test(mostrarFornecedor(l.fornecedor))
                                                                ? `código ${mostrarFornecedor(l.fornecedor)} (sistema antigo)`
                                                                : `${mostrarFornecedor(l.fornecedor)} (fora da lista)`}
                                                        </option>
                                                    )}
                                                    {fornecedores.map(f => <option key={f.id} value={f.nome}>{f.nome}</option>)}
                                                </select>
                                            </td>
                                            <td className="col-vunit">
                                                <input type="number" value={l.valor_unitario}
                                                    onChange={e => updateLinhaCompra(i, 'valor_unitario', e.target.value)}
                                                    onBlur={e => { if (e.target.value !== '') updateLinhaCompra(i, 'valor_unitario', formatarUnitario(e.target.value)); }}
                                                    className="inp-val" min="0" step="0.0001" />
                                            </td>
                                            <td className="col-vtotal">
                                                <span className="inp-val-readonly">{fmtMoney(l.valor_total)}</span>
                                            </td>
                                            <td className="col-ef">
                                                <span className="ef-cell-wrap">
                                                    <span className="ef-cell-left">
                                                        {ef ? (() => {
                                                            const efVal = toNum(ef.valor_total);
                                                            const compraVal = toNum(l.valor_total);
                                                            const diff = efVal - compraVal;
                                                            const cruzOk = Math.abs(diff) < 0.01;
                                                            return (
                                                                <span className="ef-exists-wrap">
                                                                    <button
                                                                        className={`btn-ef btn-ef-exists ef-estado-${ef.estado}`}
                                                                        onClick={() => setModalEf(ef)}
                                                                        title={`${ef.numero} – ${{ PENDENTE: 'Aguarda Fatura', ENVIADA: 'Aguarda Fatura', RECEBIDA: 'Associada' }[ef.estado] || ef.estado}`}
                                                                    >
                                                                        {ef.numero}
                                                                        <LiquidText>{ef.estado === 'ENVIADA' ? ' ✓' : ''}</LiquidText>
                                                                    </button>
                                                                    <button
                                                                        className="btn-ef-copy"
                                                                        onClick={e => { e.stopPropagation(); navigator.clipboard.writeText(ef.numero).catch(() => {}); e.currentTarget.textContent = '✓'; setTimeout(() => { if (e.currentTarget) e.currentTarget.textContent = '⎘'; }, 1500); }}
                                                                        title="Copiar número EF"
                                                                    ><OrcamentoIcon name="copy" fallback="⎘" /></button>
                                                                    <span
                                                                        className={`ef-cruza ${cruzOk ? 'ef-cruza-ok' : 'ef-cruza-dif'}`}
                                                                        title={cruzOk ? 'EF coincide com total compra' : `EF: ${fmtMoney(efVal)} | Compra: ${fmtMoney(compraVal)} | Dif: ${diff > 0 ? '+' : ''}${fmtMoney(diff)}`}
                                                                    >
                                                                        <LiquidText>{cruzOk ? '✓' : `${diff > 0 ? '+' : ''}${fmtMoney(diff)}`}</LiquidText>
                                                                    </span>
                                                                    <button
                                                                        className="btn-ef-apagar"
                                                                        onClick={() => handleApagarEF(ef)}
                                                                        title="Apagar encomenda"
                                                                    ><DeleteIcon /></button>
                                                                </span>
                                                            );
                                                        })() : (
                                                            <button
                                                                className="btn-ef btn-ef-gerar"
                                                                onClick={() => handleGerarEF(i)}
                                                                disabled={saving || isNew}
                                                                title={isNew ? 'Guarde o orçamento primeiro' : 'Gerar encomenda a fornecedor'}
                                                            >
                                                                {saving ? '...' : (linhasCompra.filter(x => x.selecionada).length > 1 ? `+ EF (${linhasCompra.filter(x => x.selecionada).length})` : '+ EF')}
                                                            </button>
                                                        )}
                                                    </span>
                                                    {linhasCompra.length > 1 && (
                                                        <>
                                                            <span className="ef-sep-v" />
                                                            <button className="btn-rm-linha btn-rm-inline"
                                                                onClick={() => removeLinhaCompra(i)}
                                                                title="Remover linha"><DeleteIcon /></button>
                                                        </>
                                                    )}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="ord-table-footer">
                        <button className="btn-add-linha" onClick={addLinhaCompra}><OrcamentoIcon name="plus" fallback="+" /> Adicionar linha</button>
                        {Math.ceil(linhasCompra.length / COMPRA_POR_PAGINA) > 1 && (
                            <div className="compra-paginacao">
                                <button className="pg-arrow" onClick={() => setCompraPage(p => Math.max(0, p - 1))} disabled={compraPage === 0}>‹</button>
                                {Array.from({ length: Math.ceil(linhasCompra.length / COMPRA_POR_PAGINA) }, (_, idx) => (
                                    <button key={idx} className={`pg-num${compraPage === idx ? ' pg-active' : ''}`} onClick={() => setCompraPage(idx)}>{idx + 1}</button>
                                ))}
                                <button className="pg-arrow" onClick={() => setCompraPage(p => Math.min(Math.ceil(linhasCompra.length / COMPRA_POR_PAGINA) - 1, p + 1))} disabled={compraPage === Math.ceil(linhasCompra.length / COMPRA_POR_PAGINA) - 1}>›</button>
                            </div>
                        )}
                        <div className="ord-total-row">
                            <span className="ord-total-label">TOTAL COMPRA</span>
                            <span className="ord-total-val">{fmtMoney(totalCompra)}</span>
                        </div>
                    </div>
                    </div>{/* /ord-section compra */}

                    {/* ==================== VENDA ==================== */}
                    <div className="ord-section">
                    <div className="ord-section-title" style={{display:'flex',alignItems:'center',gap:8}}>
                        <span>VENDA</span>
                        <div className="ord-sale-versions" role="group" aria-label="Versões de venda">
                            {Object.keys(versoesVenda).map(Number).sort((a,b)=>a-b).map(v => (
                                <button key={v} aria-pressed={v === versaoAtiva} onClick={() => setVersaoAtiva(v)} style={{
                                    padding:'2px 10px', borderRadius:4, border:'none', cursor:'pointer',
                                    fontWeight:700, fontSize:12,
                                    background: v === versaoAtiva ? '#fff' : 'rgba(255,255,255,0.25)',
                                    color: v === versaoAtiva ? '#5b4fcf' : '#fff',
                                }}>v{v}</button>
                            ))}
                            <button onClick={addVersaoVenda} title="Adicionar versão de venda" style={{
                                padding:'2px 10px', borderRadius:4, border:'none', cursor:'pointer',
                                fontWeight:700, fontSize:14, background:'rgba(255,255,255,0.2)', color:'#fff'
                            }}><OrcamentoIcon name="plus" fallback="+" /></button>
                            <button onClick={removerVersaoVenda} disabled={Object.keys(versoesVenda).length <= 1} title={Object.keys(versoesVenda).length <= 1 ? 'É necessário manter uma versão de venda' : `Eliminar versão v${versaoAtiva}`} aria-label="Eliminar versão de venda"><DeleteIcon /></button>
                        </div>
                        {/* Os dois botões num par: com o margin-left: auto em ambos,
                            a ordem em que apareciam dependia de qual apanhava o
                            espaço livre primeiro. */}
                        <div className="ord-acoes-venda">
                            <button className="btn-copy-all" onClick={() => ficheiroOrdemRef.current?.click()}
                                disabled={aLerOrdem}
                                title="Importar nota de encomenda do cliente em PDF">
                                <OrcamentoIcon name="upload" fallback="⇪" /> {aLerOrdem ? 'A ler…' : 'Importar NE'}
                            </button>
                            <input ref={ficheiroOrdemRef} type="file" accept="application/pdf,.pdf" hidden
                                onChange={e => importarOrdemCompra(e.target.files?.[0])} />
                            <button className="btn-copy-all" onClick={() => copiarDescricoes(linhasVendaAtiva, 'venda')}
                                title="Copiar a descrição de todas as linhas, uma por linha">
                                <LiquidText>{copiado === 'venda' ? '✓ Copiado' : '⧉ Copiar descrições'}</LiquidText>
                            </button>
                        </div>
                    </div>
                    <div className="ord-table-wrap">
                        <table className="ord-table ord-table-venda">
                            <thead>
                                <tr>
                                    <th className="col-num">#</th>
                                    <th className="col-qtd">QTD</th>
                                    <th className="col-desc">DESCRIÇÃO</th>
                                    <th className="col-vunit">V. UNITÁRIO</th>
                                    <th className="col-vtotal col-vtotal-rm">TOTAL</th>
                                    <th className="col-guia" title="Incluir na Guia">GUIA</th>
                                </tr>
                            </thead>
                            <tbody>
                                {linhasVendaAtiva.map((l, i) => (
                                    <tr key={l._key} className={l.descricao || l.qtd ? 'linha-preenchida' : ''}>
                                        <td className="col-num td-num ord-sale-order"><span>{i + 1}</span><div>
                                            <button type="button" title="Subir linha" aria-label={`Subir linha ${i + 1}`} disabled={i === 0} onClick={() => moverLinhaVenda(i, i - 1)}><OrcamentoIcon name="up" fallback="↑" /></button>
                                            <button type="button" title="Descer linha" aria-label={`Descer linha ${i + 1}`} disabled={i === linhasVendaAtiva.length - 1} onClick={() => moverLinhaVenda(i, i + 1)}><OrcamentoIcon name="down" fallback="↓" /></button>
                                        </div></td>
                                        <td className="col-qtd">
                                            <input type="number" value={l.qtd}
                                                onChange={e => updateLinhaVenda(i, 'qtd', e.target.value)}
                                                onBlur={e => {
                                                    const val = parseFloat(e.target.value);
                                                    if (!isNaN(val)) updateLinhaVenda(i, 'qtd', fmtQtd(val));
                                                }}
                                                className="inp-qtd" min="0" step="0.1" />
                                        </td>
                                        <td className="col-desc">
                                            <div className="td-desc-wrap">
                                                <textarea value={l.descricao}
                                                    onChange={e => {
                                                        updateLinhaVenda(i, 'descricao', e.target.value);
                                                        e.target.style.height = 'auto';
                                                        e.target.style.height = e.target.scrollHeight + 'px';
                                                    }}
                                                    onFocus={e => {
                                                        e.target.style.height = 'auto';
                                                        e.target.style.height = e.target.scrollHeight + 'px';
                                                    }}
                                                    className="inp-desc inp-desc-ta"
                                                    rows={2} />
                                                <button className="btn-copy-desc" title="Copiar descrição"
                                                    onClick={() => navigator.clipboard.writeText(l.descricao || '')}><OrcamentoIcon name="copy" fallback="⧉" /></button>
                                            </div>
                                        </td>
                                        <td className="col-vunit">
                                            <input type="number" value={l.valor_unitario}
                                                onChange={e => updateLinhaVenda(i, 'valor_unitario', e.target.value)}
                                                    onBlur={e => { if (e.target.value !== '') updateLinhaVenda(i, 'valor_unitario', formatarUnitario(e.target.value)); }}
                                                className="inp-val" min="0" step="0.0001" />
                                        </td>
                                        <td className="col-vtotal col-vtotal-rm">
                                            <span className="venda-total-wrap">
                                                <span className="inp-val-readonly">{fmtMoney(l.valor_total)}</span>
                                                {linhasVendaAtiva.length > 1 && (
                                                    <>
                                                        <span className="ef-sep-v" />
                                                        <button className="btn-rm-linha btn-rm-inline"
                                                            onClick={() => removeLinhaVenda(i)}
                                                            title="Remover linha"><DeleteIcon /></button>
                                                    </>
                                                )}
                                            </span>
                                        </td>
                                        <td className="col-guia" style={{textAlign:'center'}}>
                                            <input type="checkbox"
                                                checked={l.na_guia !== false}
                                                onChange={e => updateLinhaVenda(i, 'na_guia', e.target.checked)}
                                                title="Incluir na Guia" />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="ord-table-footer">
                        <button className="btn-add-linha" onClick={addLinhaVenda}><OrcamentoIcon name="plus" fallback="+" /> Adicionar linha</button>
                    </div>
                    </div>{/* /ord-section venda */}

                    {/* Totais finais */}
                    <div className="ord-totais-finais">
                        <div className="ord-tot-row">
                            <span className="ord-tot-l">TOTAL VENDA (s/ IVA)</span>
                            <span className="ord-tot-v">{fmtMoney(totalVenda)}</span>
                        </div>
                        <div className="ord-tot-row">
                            <span className="ord-tot-l">IVA (23%)</span>
                            <span className="ord-tot-v">{fmtMoney(ivaVenda)}</span>
                        </div>
                        <div className="ord-tot-row ord-tot-row-total">
                            <span className="ord-tot-l">TOTAL (c/ IVA)</span>
                            <span className="ord-tot-v">{fmtMoney(totalVendaComIva)}</span>
                        </div>
                        <div className="ord-tot-row ord-tot-row-sep">
                            <span className="ord-tot-l">MARGEM</span>
                            <span className={`ord-tot-v ${margem >= 0 ? 'pos' : 'neg'}`}>{fmtMoney(margem)}</span>
                        </div>
                        <div className="ord-tot-row">
                            <span className="ord-tot-l">%</span>
                            <span className={`ord-tot-v ${margem >= 0 ? 'pos' : 'neg'}`}>
                                {pctMargem.toLocaleString('pt-PT', { minimumFractionDigits: 0, maximumFractionDigits: 1 })}%
                            </span>
                        </div>
                    </div>

                    {/* Anexo Nota de Encomenda do Cliente */}
                    {!isNew && (
                        <div className="ne-anexo-area">
                            <span className="ne-anexo-label"><OrcamentoIcon name="paperclip" fallback="" /> Nota de Encomenda (anexo)</span>
                            {neFicheiro ? (
                                <span className="ne-anexo-file">
                                    <button className="ne-anexo-link" style={{background:'none',border:'none',cursor:'pointer',padding:0,font:'inherit'}} onClick={async () => {
                                        try {
                                            const token = localStorage.getItem('token');
                                            const baseURL = api.defaults.baseURL;
                                            const fileUrl = `${baseURL}/orcamentos/${id}/download-ne`;
                                            const res = await fetch(fileUrl, { headers: { 'Authorization': `Bearer ${token}` } });
                                            if (!res.ok) throw new Error();
                                            const blob = await res.blob();
                                            const contentDisposition = res.headers.get('Content-Disposition') || '';
                                            const match = contentDisposition.match(/filename="?([^"]+)"?/);
                                            const filename = match ? match[1] : neFicheiro.split('/').pop();
                                            const a = document.createElement('a');
                                            a.href = URL.createObjectURL(blob);
                                            a.download = filename;
                                            a.click();
                                        } catch { notify('Erro ao descarregar ficheiro'); }
                                    }}>
                                        <OrcamentoIcon name="download" fallback="↓" /> {neFicheiro.split('/').pop()}
                                    </button>
                                    <button className="ne-anexo-rm" title="Remover anexo" onClick={async () => {
                                        if (!await confirm('Remover o anexo?')) return;
                                        const resposta = await api.delete(`/orcamentos/${id}/upload-ne`);
                                        setNeFicheiro(resposta.data.ne_ficheiro || null);
                                    }}><DeleteIcon /></button>
                                </span>
                            ) : (
                                <label className="ne-anexo-btn" aria-disabled={neUploading}>
                                    <OrcamentoIcon name="upload" fallback="↑" />
                                    {neUploading ? 'A carregar...' : 'Anexar ficheiro'}
                                    <input className="ne-anexo-input" type="file" disabled={neUploading} onChange={async (e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;
                                        setNeUploading(true);
                                        try {
                                            const fd = new FormData();
                                            fd.append('ficheiro', file);
                                            const res = await api.post(`/orcamentos/${id}/upload-ne`, fd, {
                                                headers: { 'Content-Type': 'multipart/form-data' }
                                            });
                                            setNeFicheiro(res.data.ne_ficheiro);
                                        } catch { notify('Erro ao carregar ficheiro'); }
                                        finally { setNeUploading(false); e.target.value = ''; }
                                    }} />
                                </label>
                            )}
                        </div>
                    )}

                    {/* Botões finais */}
                    <div className="ord-bottom-actions">
                        <button className="ord-btn ord-btn-back-b" onClick={handleSairRequest}>Sair</button>
                        {!isNew && (
                            <button className="ord-btn ord-btn-duplicar" onClick={handleDuplicar}>Duplicar</button>
                        )}
                        {!isNew && !obraAssociada && (
                            <button className="ord-btn ord-btn-converter" data-liquid-secondary="true" onClick={handleConverterObra}>
                                <OrcamentoIcon name="building" fallback="" /> Converter em Obra
                            </button>
                        )}
                        {!isNew && (
                            <>
                                <button className="ord-btn ord-btn-doc" onClick={() => handleAbrirDocumento('orcamento')}><OrcamentoIcon name="print" fallback="🖨️" /> Imprimir</button>
                                <button className="ord-btn ord-btn-doc" onClick={() => handleDownloadPDF('orcamento')}><OrcamentoIcon name="document" fallback="📄" /> PDF</button>
                                <button className="ord-btn ord-btn-guia" onClick={() => handleAbrirDocumento('guia')}><OrcamentoIcon name="print" fallback="🖨️" /> Imprimir Guia</button>
                                <button className="ord-btn ord-btn-guia" onClick={() => handleDownloadPDF('guia')}><OrcamentoIcon name="truck" fallback="🚚" /> Guia PDF</button>
                            </>
                        )}
                        <button className="ord-btn ord-btn-save" onClick={() => handleSave(false)} disabled={saving}>
                            {saving ? 'A guardar...' : <><OrcamentoIcon name="save" fallback="💾" /> Guardar</>}
                        </button>
                    </div>
            </div>

            {/* Modal Encomenda */}
            {modalEf && (
                <ModalEncomenda
                    ef={modalEf}
                    todasAsEncomendas={encomendas}
                    onClose={() => setModalEf(null)}
                    onSaved={() => { fetchEncomendas(); fetchOrcamento(); }}
                />
            )}

            {/* Modal Sair com Alterações Não Gravadas */}
            {showExitModal && (
                <OrcamentoDialog style={{zIndex: 9999}} onClose={() => setShowExitModal(false)}>
                    <div className="modal-ef" style={{maxWidth: 500}}>
                        <div className="modal-ef-header">
                            <h3 className="orc-dialog-title">Alterações não guardadas</h3>
                            <button className="modal-close" aria-label="Fechar" onClick={() => setShowExitModal(false)}><OrcamentoIcon name="close" fallback="✕" /></button>
                        </div>
                        <div className="modal-form-body">
                            <p style={{marginBottom: '20px', fontSize: '15px'}}>Tem alterações não guardadas. O que deseja fazer?</p>
                            <div className="modal-form-actions" style={{justifyContent: 'center', gap: '8px', flexWrap: 'nowrap', marginTop: '10px'}}>
                                <button className="btn-modal-cancel" onClick={() => setShowExitModal(false)}>Cancelar</button>
                                <button className="btn-modal-danger" onClick={() => { setShowExitModal(false); navigate('/orcamentos'); }}>Sair sem gravar</button>
                                <button className="btn-modal-save" style={{fontWeight: 'bold', whiteSpace: 'nowrap'}} onClick={() => { setShowExitModal(false); handleSave(true); }}>Gravar e Sair</button>
                            </div>
                        </div>
                    </div>
                </OrcamentoDialog>
            )}
        </div>
    );
}

export default function OrcamentoDetalhe() {
    return <OrcamentoFeedbackProvider><OrcamentoDetalheContent /></OrcamentoFeedbackProvider>;
}
